'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React from 'react';

import PropTypes from 'prop-types';

import ButtonCTA from 'components/ui/ButtonCTA';
import Img from 'components/ui/Img';
import UltraBoldHeading from 'components/ui/UltraBoldHeading';

import { blockRootProps, getColor } from 'utils';

import styles from './BlockCategoryDetailIntro.module.scss';

const BlockCategoryDetailIntro = ({
    __typename,
    anchorId,
    headline,
    imageDesktop: desktopImage,
    imageMobile: mobileImage,
    primaryCta,
    secondaryCta,
    backgroundColor,
    floorColor,
}) => {
    if (!headline) {
        return null;
    }

    const hasCtas = primaryCta?.text || secondaryCta?.text;
    const hasImage = desktopImage?.url || mobileImage?.url;
    const fallbackImage = mobileImage?.url ? mobileImage : desktopImage;

    return (
        <div
            {...blockRootProps(anchorId, __typename)}
            className={styles.categoryDetailIntro}
            style={{
                '--hero-bg-color': backgroundColor
                    ? getColor(backgroundColor)
                    : undefined,
                '--floor-color': floorColor ? getColor(floorColor) : undefined,
            }}
        >
            <div className={styles.textBlock}>
                <div className={styles.headlineWrap}>
                    <div className={styles.headline}>
                        <UltraBoldHeading
                            baseTheme={'displayMedium'}
                            headline={headline}
                        />
                    </div>
                </div>
                {hasCtas && (
                    <div className={styles.ctaGroup}>
                        {primaryCta?.text && <ButtonCTA {...primaryCta} />}
                        {secondaryCta?.text && <ButtonCTA {...secondaryCta} />}
                    </div>
                )}
            </div>
            {hasImage && (
                <div className={styles.imageColumn}>
                    <Img
                        className={styles.heroImage}
                        src={fallbackImage.url}
                        fallbackImageWidth={768}
                        priority
                        alt={
                            desktopImage?.description ||
                            mobileImage?.description ||
                            ''
                        }
                        width={fallbackImage.width}
                        height={fallbackImage.height}
                        customSources={[
                            ...(desktopImage?.url
                                ? [
                                      {
                                          breakpoint: 1024,
                                          src: desktopImage.url,
                                          imageWidth: 1200,
                                          width: desktopImage.width,
                                          height: desktopImage.height,
                                      },
                                  ]
                                : []),
                            {
                                src: fallbackImage.url,
                                imageWidth: 768,
                                width: fallbackImage.width,
                                height: fallbackImage.height,
                            },
                        ]}
                    />
                </div>
            )}
        </div>
    );
};

BlockCategoryDetailIntro.propTypes = {
    __typename: PropTypes.string,
    anchorId: PropTypes.string,
    headline: PropTypes.object,
    imageDesktop: PropTypes.shape({
        description: PropTypes.string,
        width: PropTypes.number,
        height: PropTypes.number,
        url: PropTypes.string,
    }),
    imageMobile: PropTypes.shape({
        description: PropTypes.string,
        width: PropTypes.number,
        height: PropTypes.number,
        url: PropTypes.string,
    }),
    primaryCta: PropTypes.object,
    secondaryCta: PropTypes.object,
    backgroundColor: PropTypes.string,
    floorColor: PropTypes.string,
};

export default BlockCategoryDetailIntro;
